export default {
    insurance_document: null,
    insurance_agent: null,
    agents: [],
}
